export default {
    booking: {
        reservations: {
            export: {
                atLeastOneService: "Merci de sélectionner au moins un jeu",
            },
        },
    },
};
